import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "api";
import { T_Category, T_Category_Type, T_UpdateBlog } from "dtos/category.dto";
import { T_Api_Paginated } from "./api.types";

export const categoryService = {
  useGetAllPaginated: ({
    page,
    limit,
    visibility = [],
    type = [],
  }: {
    page: number;
    limit: number;
    visibility?: string[];
    type?: T_Category_Type[];
  }) => {
    return useQuery({
      queryKey: ["category/all", page, limit, visibility, type],
      queryFn: async () => {
        const res = await api.get(
          `/category?page=${page}&limit=${limit}&type=${JSON.stringify(type)}&visiblity_type=${JSON.stringify(visibility)}`,
        );
        return res.data?.result as T_Api_Paginated<T_Category>;
      },
    });
  },
  useAddCategory: () => {
    return useMutation({
      mutationKey: ["category/add"],
      mutationFn: async (body: T_Category) => {
        return api.post("/category", body);
      },
    });
  },
  useSearchCategory: ({ page, limit, term }: { page: number; limit: number; term?: string }) => {
    return useQuery({
      queryKey: ["category/all", page, limit],
      queryFn: async () => {
        const res = await api.get(`/category?page=${page}&limit=${limit}&queryString=${term}`);
        return res.data?.result as T_Api_Paginated<T_Category>;
      },
    });
  },
  useGetByIdOrSlug: (id: string | undefined) => {
    return useQuery({
      queryKey: ["category", id],
      queryFn: async () => {
        const res = await api.get(`/category/${id}`);
        return res.data?.result as T_Category;
      },
      enabled: !!id,
    });
  },
  useUpdatecategory: () => {
    return useMutation({
      mutationKey: ["category/update"],
      mutationFn: async ({ id, body }: { id: string; body: T_UpdateBlog }) => {
        return api.put(`/category/${id}`, body);
      },
    });
  },
  useDeleteByIdOrSlug: () => {
    return useMutation({
      mutationKey: ["delete"],
      mutationFn: async (id: string) => {
        return api.delete("/category", {
          data: { id },
        });
      },
    });
  },
  useUpdateVisibility: () => {
    return useMutation({
      mutationKey: ["update/visibility"],
      mutationFn: ({ id, visiblity }: { id: string; visiblity: string }) => {
        return api.patch(`/category/visiblity/${id}`, { visblityType: visiblity });
      },
    });
  },
};
